import { makeStyles } from '@griffel/react';
import { Spinner } from '@ksb/ui';

const useStyles = makeStyles({
  rahmen: { display: 'flex', justifyContent: 'center', padding: 'var(--padding-xl) 0' },
});

export function Ladeanzeige({ text = 'Wird geladen …' }: { text?: string }) {
  const styles = useStyles();
  return (
    <div className={styles.rahmen}>
      <Spinner label={text} />
    </div>
  );
}
